module.exports = __webpack_public_path__ + "static/media/sfx_ui_pop_up_error.e27ff0f8.mp3";